export default __webpack_public_path__ + "static/media/printer.9a1e8bf7.svg";